var _rect, _g, _rect2, _g2, _rect3, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAreaChartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1751_5864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 17,
    height: 5
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 11,
    width: 16,
    height: 5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1751_5864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16H0.5V4.41379L1.5 2.2069L3 9.93103L6 3.86207L8.5 9.93103L9.5 0L12 5.51724L13 1.65517L14 4.96552L15.5 3.31034L16.5 4.41379V16Z",
    fill: "#34D399"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1751_5864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 17,
    height: 6
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5,
    width: 16,
    height: 6,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1751_5864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16H0.5V4.41379L1.5 2.2069L3 9.93103L6 3.86207L8.5 9.93103L9.5 0L12 5.51724L13 1.65517L14 4.96552L15.5 3.31034L16.5 4.41379V16Z",
    fill: "#FCD34D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1751_5864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 5
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 16,
    height: 5,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1751_5864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16H0.5V4.41379L1.5 2.2069L3 9.93103L6 3.86207L8.5 9.93103L9.5 0L12 5.51724L13 1.65517L14 4.96552L15.5 3.31034L16.5 4.41379V16Z",
    fill: "#EF4967"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaChartIcon);
export default __webpack_public_path__ + "static/media/AreaChartIcon.260a616f5d3693eed91bd89a16212d02.svg";
export { ForwardRef as ReactComponent };